import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_FILE_BASIC_03_Schema } from './M_FILE_BASIC_03_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** 작업허가서 조회 getFileCustomR3 (Global.urls.File 136-141, SP_TBM_R4) */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_FILE_BASIC_03_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['File', 'getFileCustomR3', params],
    queryFn: () => apiRequest('post', Global.urls.File.getFileCustomR3, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
